import React, {useRef} from 'react'
import { connect } from 'react-redux';
import commonActions from '../../Actions/commonActions';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import Shortcuts from '../Layout/Shortcuts';
import { useNavigate } from 'react-router-dom';
import aocustomerLogo from "../../Images/aocustomer.svg"
import aocustomerLogoDark from "../../Images/aocustomerDark.svg"
import customerLogo from "../../Images/customer.svg"
import customerLogoDark from "../../Images/customerDark.svg"
import integrationPartnerLogo from "../../Images/integrationPartner.svg"
import integrationPartnerLogoDark from "../../Images/integrationPartnerDark.svg"
import resellerLogo from "../../Images/reseller.svg"
import resellerLogoDark from "../../Images/resellerDark.svg"
import SkynetCopy from "../Fundamentals/SkynetCopy";
import SkynetIcon from "../Fundamentals/SkynetIcon";
import customerActions from "../../Actions/customerActions";
import MessageAlertLevel from "../MessageAlertLevel";
import Tooltip, {TooltipContent, TooltipTrigger} from "../Overlays/Tooltip";
import verifiedcustomer from "../../Images/verifiedcustomer.svg";
import nonverifiedcustomer from "../../Images/nonverifiedcustomer.svg";
import useModal from "../../Hooks/useModal";
import Modals from "../../Constants/modals";
import ModalManager from "../ModalManagers/ModalManager";
import CustomerModal from "./CustomerComponents/CustomerModal";
import customerRoutes from "../../Constants/Customer/customerRoutes";
import useFeatureFlags from "../../Hooks/useFeatureFlags";
import helpers from "../../Utils/helpers";
import targetGroupHelpers from "../../Utils/targetGroups";

function CustomerTopMenu({ t, customer, vbProducts }) {
    const imgRef = useRef(null);
    const navigate = useNavigate();
    const {openModal} = useModal();

    if (!customer) {
        return null;
    }
    const navigateHome = () => {
        navigate(customerRoutes.customer(customer.pathId));
    }

    const containsProduct = (productArray, productNumber) => {
        return productArray && productArray.some(product => product.productNumber === productNumber);
    }
    const getCustomerImg = () => {
        let logo = customerLogo;
        let darkmodeLogo = customerLogoDark;
        let title = "Customer";

        if (customer.vbCustomer && helpers.isAoCustomer(customer.vbCustomer) || customer.vossCustomer && helpers.isAoCustomer(customer.vossCustomer)) {
            logo = aocustomerLogo
            darkmodeLogo = aocustomerLogoDark
            title = "Accounting Office"
        } else if (helpers.isResellerCustomer(customer)) {
            logo = resellerLogo
            darkmodeLogo = resellerLogoDark
            title = "Reseller - Contact PartnerSales"
        } else if (containsProduct(vbProducts, "ADMIN.API.UTV")) {
            logo = integrationPartnerLogo
            darkmodeLogo = integrationPartnerLogoDark
            title = "Integration Partner - Contact TechSales"
        }

        return (<>
            <img className='skynet-customer-logo pt-2 cursorpointer show-on-light' alt={"Customer logo"} title={title}
                 ref={imgRef} src={logo} onClick={() => navigateHome()}/>
            <img className='skynet-customer-logo pt-2 cursorpointer show-on-dark' alt={"Customer logo"} title={title}
                 ref={imgRef} src={darkmodeLogo} onClick={() => navigateHome()}/>
        </>)
    }
    
    const getCustomerVerified = () => {
        let imgSrc = verifiedcustomer;
        let infoText = t('maininfocontainer.verifiedcustomer');
        
        if (!customer.vossCustomer.isVerified) {
            imgSrc = nonverifiedcustomer;
            infoText = t('maininfocontainer.nonverifiedcustomer');
        }
        
        return <>
            <TooltipTrigger>
                {<img className='pr-8 pt-6' alt={infoText} src={imgSrc}/>}
            </TooltipTrigger>
            <TooltipContent>
                <div>{infoText}</div>
            </TooltipContent>
        </>
    }
    
    const customerEditModal = () => {
        if (customer.vbCustomer && customer.vossCustomer) {
            return Modals.EditVossAndVbCustomer
        }
        
        if (customer.vbCustomer) {
            return Modals.EditVbCustomer
        }
        
        if (customer.vossCustomer) {
            return Modals.EditVossCustomer
        }
    }

    const modalsComponents = {
        [Modals.EditVossAndVbCustomer]: CustomerModal,
        [Modals.CreateSaasCustomer]: CustomerModal,
        [Modals.EditVbCustomer]: CustomerModal,
        [Modals.EditVossCustomer]: CustomerModal
    };
    
    return <>
        <div className="d-flex pb-8">
            <div>
                {getCustomerImg()}
            </div>
            <div className='pl-8'>
                <div className="d-flex">
                       {customer.vossCustomer &&
                        <Tooltip>
                            {getCustomerVerified()}
                        </Tooltip>
                    }
                    <h1 className="m-0 bold">{(targetGroupHelpers.isNonInteractive(customer) ? "Non-interactive: " : "") + customer.name}</h1>
                    <SkynetCopy label={t("common.customername")} value={customer.name}></SkynetCopy>
                </div>
                <div>
                    <span className="pr-8">{t("common.customernumber")}:</span>
                    <SkynetCopy label={t("common.customernumber")}
                                value={customer.vbCustomer?.customerNumber ?? customer.vossCustomer?.customerNumber}>{customer.vbCustomer?.customerNumber ?? customer.vossCustomer?.customerNumber}</SkynetCopy>
                </div>
                <div>
                    <span className="pr-8">{t("common.organizationnumber")}:</span>
                    <SkynetCopy label={t("common.organizationnumber")}
                                value={customer.orgNo}>{customer.orgNo}</SkynetCopy>
                </div>
                <div>
                    <span className="pr-8">{t("common.customerid")}:</span>
                    <SkynetCopy label={t("common.customerid")}
                                value={customer.vossCustomer?.id}>{customer.vossCustomer?.id}</SkynetCopy>
                </div>
            </div>
            {!customer.vossCustomer &&
                <div className="ml-24 mt-4">
                    <MessageAlertLevel
                        message={<>Kunden har inte tillgång till onlinetjänster. Om du vill aktivera detta, <a
                            className="text-nowrap"
                            onClick={() => openModal(Modals.CreateSaasCustomer)}>{"klicka här"}</a></>}/>
                </div>
            }
            {!targetGroupHelpers.isNonInteractive(customer) &&
                <div className='ms-auto pt-2 px-2'>
                    <SkynetIcon icon="vismaicon-edit" onClick={() => openModal(customerEditModal())}/>
                </div>
            }
        </div>
        <div className="mb-8 skynet-customer-shortcuts-container">
            <Shortcuts/>
        </div>
        <ModalManager modals={modalsComponents}/>
    </>
}

function mapStateToProps(state) {
    return {
        customer: state.CustomerReducer.customer,
        user: state.CommonReducer.user,
        vbProducts: state.CustomerReducer.vbProducts
    }
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch)
    }
}
export default (connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomerTopMenu)));